import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const ItemHolder = ({ title, icon }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {icon}
      <Typography component="h4" variant="h5">
        {title}
      </Typography>
    </Box>
  );
};

export default ItemHolder;
